import React from "react";
import WebsiteContainer from "./WebsiteContainer";
import { Div, Text, Row, Col } from "atomize";
import AnimateLink from "../common/AnimateLink";
import ImageLink from "./ImageLink";

const PricingScheduleDemo = ({ footer }) => {
  return (
    <Div
      bg="black800"
      border="1px solid"
      borderColor="border"
      textAlign={{ xs: "center", md: "left" }}
      p="2rem 2.4rem"
    >
      <Row m="0" flexDir={{ xs: "column", md: "row" }}>
        <Col
          size={{ xs: "12", md: "6" }}
          d="flex"
          p="0"
          align="center"
          justify={{ xs: "center", md: "left" }}
          border={{ r: { md: "1px solid" } }}
          borderColor="#393939"
        >
          <Div>
            <Text
              textSize="heading3"
              style={{ lineHeight: "30px" }}
              textWeight="bold"
              maxW="16.25rem"
            >
              {footer.text}
            </Text>
          </Div>
        </Col>

        <Col size={{ xs: "12", md: "6" }} textAlign="center">
          <Text
            textTransform="uppercase"
            textColor="#6E6E6E"
            textWeight="bold"
            textSize="caption2"
            style={{ letterSpacing: "1.5px" }}
          >
            {footer.reviewText}
          </Text>
          <Div d="flex" maxW="13.5rem" m={{ t: "10px", x: "auto" }}>
            <ImageLink link={footer.imageLink1} w="100%" m={{ r: "1.5rem" }}>
              <Div
                flexGrow="1"
                bgImg={footer.image1}
                p={{ b: "55%" }}
                bgSize="contain"
                bgPos="center"
                bgRepeat="no-repeat"
              />
            </ImageLink>
            <ImageLink link={footer.imageLink2} w="100%">
              <Div
                flexGrow="1"
                bgImg={footer.image2}
                p={{ b: "22.4%" }}
                bgSize="contain"
                bgPos="center"
                bgRepeat="no-repeat"
                m={{ t: "5px" }}
              />
            </ImageLink>
          </Div>
        </Col>
      </Row>
    </Div>
  );
};

export default PricingScheduleDemo;
